const localState = {
    show: false,
}

const mutations = {
    toggleShow: (state) => {
        state.show = !state.show
    },
}

const actions = {}

const getters = {
    showGetters: (state) => state.show,
}

export default {
    namespaced: true,
    state: localState,
    mutations,
    actions,
    getters,
}
